import Vue from 'vue'
import VueRouter from 'vue-router'

// import { canNavigate } from '@/libs/acl/routeProtection'
import { logout, isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { userService } from '@/_helpers/user';

Vue.use(VueRouter)

const router = new VueRouter({
  //mode: 'history',
  base: '/' + window.location.pathname,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/layers',
      name: 'layers',
      component: () => import('@/views/Layers/Layers.vue'),
      meta: {
        pageTitle: 'Layers',
        breadcrumb: [
          {
            text: 'Layers',
            active: true,
          },
        ],
      },
    },
    {
      path: '/MapManager',
      name: 'mapmanager',
      component: () => import('@/views/MapManager/MapManager.vue'),
      meta: {
        pageTitle: 'MapManager',
        breadcrumb: [
          {
            text: 'MapManager',
            active: true,
          },
        ],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/Users/Users.vue'),
      meta: {
        pageTitle: 'Utilisateurs',
        breadcrumb: [
          {
            text: 'Utilisateurs',
            active: true,
          },
        ],
      },
    },
    {
      path: '/editUser/:key',
      name: 'editUser',
      component: () => import('@/views/EditUser/EditUser.vue'),
      meta: {
        pageTitle: 'Édition utilisateur',
        breadcrumb: [
          {
            text: 'Édit. utilisateur',
            active: true,
          },
        ],
      },
    },
    {
      path: '/backofficeUsers',
      name: 'backofficeUsers',
      component: () => import('@/views/BackofficeUsers/BackofficeUsers.vue'),
      meta: {
        pageTitle: 'Utilisateurs Backoffice',
        breadcrumb: [
          {
            text: 'Utilisateurs Backoffice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/editBackofficeUser/:key',
      name: 'editBackofficeUser',
      component: () => import('@/views/EditBackofficeUser/EditBackofficeUser.vue'),
      meta: {
        pageTitle: 'Édition utilisateur Backoffice',
        breadcrumb: [
          {
            text: 'Édit. utilisateur Backoffice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/conf/:type/:id',
      name: 'editConf',
      component: () => import('@/views/EditConf/EditConf.vue'),
      meta: {
        pageTitle: 'Édition de configuration',
        breadcrumb: [
          {
            text: 'Édit. configuration',
            active: true,
          },
        ],
      },
    },
    {
      path: '/applications',
      name: 'applications',
      component: () => import('@/views/Applications/Applications.vue'),
      meta: {
        pageTitle: 'Applications',
        breadcrumb: [
          {
            text: 'Applications',
            active: true,
          },
        ],
      },
    },
    {
      path: '/defaultConf',
      name: 'defaultConf',
      component: () => import('@/views/DefaultConf/DefaultConf.vue'),
      meta: {
        pageTitle: 'Configurations de base',
        breadcrumb: [
          {
            text: 'Conf. de base',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sources',
      name: 'sources',
      component: () => import('@/views/Sources/Sources.vue'),
      meta: {
        pageTitle: 'Portal Sources',
        breadcrumb: [
          {
            text: 'Portal Sources',
            active: true,
          },
        ],
      },
    },
    {
      path: '/editSource/:id',
      name: 'editSource',
      component: () => import('@/views/EditSource/EditSource.vue'),
      meta: {
        pageTitle: 'Édition de source',
        breadcrumb: [
          {
            text: 'Édit. source',
            active: true,
          },
        ],
      },
    },
    {
      path: '/translations',
      name: 'translations',
      component: () => import('@/views/Translations/Translations.vue'),
      meta: {
        pageTitle: 'Traductions',
        breadcrumb: [
          {
            text: 'Traductions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/owner',
      name: 'owner',
      component: () => import('@/views/Owner/Owner.vue'),
      meta: {
        pageTitle: 'Propriétaire',
        breadcrumb: [
          {
            text: 'Propriétaire',
            active: true,
          },
        ],
      },
    },
    {
      path: '/themes',
      name: 'themes',
      component: () => import('@/views/Themes/Themes.vue'),
      meta: {
        pageTitle: 'Gestion des thèmes',
        breadcrumb: [
          {
            text: 'Gestion des thèmes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/editTheme/:key',
      name: 'editTheme',
      component: () => import('@/views/EditTheme/EditTheme.vue'),
      meta: {
        pageTitle: 'Édition de thème',
        breadcrumb: [
          {
            text: 'Éditition de thème',
            active: true,
          },
        ],
      },
    },
    {
      path: '/appChoice',
      name: 'appChoice',
      component: () => import('@/views/AppChoice/AppChoice.vue'),
      meta: {
        pageTitle: 'Choix de l\'Application'
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import('@/views/Forgot/Forgot.vue'),
      meta: {
        layout: 'full'
      },
    },
    {
      path: '/logout',
      name: 'logout',
      redirect: () => {
        return { name: 'login', params: { fromLogout: true } }
      }
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (to.name === 'forgot') {
    return next()
  } else if (to.name === 'login' && to.params.fromLogout === true) {
    logout()
    return next()
  } else if (to.name === 'login' && to.query.t && to.query.t !== '') {
    logout()
    return next({ name: 'login', params: { token: to.query.t, appKey: to.query.appKey } })
  }

  if (to.name === 'login' && !isLoggedIn) return next()
  if (!isLoggedIn) return next({ name: 'login' })

  if (!userService.canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'home' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }
  if(to.name === 'home'){
    if (!Vue.prototype.$ccgeoVersion) {
      return next({ name: 'users' })
    }else{
      return next({ name: 'backofficeUsers' })
    }
    
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
